<template>
  <v-timeline align-top dense class="timeline-window">
    <TimelineItem
      v-for="item in items"
      :key="item._id"
      :item="item"
      :title-getter="titleGetter"
      :link-getter="linkGetter"
      :description-getter="descriptionGetter"
      @delete="deleteItem(item)"
    />
    <v-timeline-item color="grey lighten-3" small>
      <v-layout pt-3>
        <v-flex xs2>
          <strong>{{ createdAt | shortDate }}</strong>
        </v-flex>
        <v-flex>
          <strong>Création</strong>
        </v-flex>
      </v-layout>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import { objectIdToDate } from "../../utils";
import TimelineItem from "./TimelineItem";
import { mapActions, mapState } from "vuex";

export default {
  components: { TimelineItem },
  props: ["targetId", "titleGetter", "linkGetter", "descriptionGetter"],
  async mounted() {
    this.reload();
  },
  timers: {
    reload: { time: 5000, autostart: true, repeat: true }
  },

  computed: {
    ...mapState("timeline", ["items"]),

    createdAt() {
      return objectIdToDate(this.targetId);
    }
  },

  methods: {
    ...mapActions("timeline", ["deleteTimelineItem", "fetchTimelineItems"]),

    async reload() {
      await this.fetchTimelineItems({
        targetId: this.targetId
      });
    },
    async deleteItem(item) {
      await this.deleteTimelineItem({
        item
      });
    }
  }
};
</script>
<style scoped>
.timeline-window {
  height: calc(100vh - 170px);
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
